import { Chip } from '@mui/material'
import ApiClient from '../../backend/ApiClient'
import API_URLS from '../../backend/ApiUrls'
import { IContract } from '../../definitions/Contract'
import ApprovalManager from '../../managers/ApprovalManager'
import { CSimilarity } from '../../managers/ContractsManager'
import { useAppDispatch } from '../../store/Hooks'
import { changeRoute } from '../../store/slices/SessionSlice'
import SmartCard from '../controls/cards/SmartCard'
import { Cell, Column, Row, SmartTable } from '../controls/table'
import useCommand from '../hooks/useCommand'

type ContractRow = IContract & { csi: CSimilarity, counterpartySignatory: any }

export default function Contracts() {
    const dispatch = useAppDispatch()

    const getStatusChip = (status: string) => {
        switch (status) {
            case 'Live':
                return <Chip label='Live' color='success' size='small' />
            case 'Draft':
                return <Chip label='Draft' color='default' size='small' />
            case 'Archived':
                return <Chip label='Archived' color='info' size='small' />
        }
    }

    const columnsPendings: Column<ContractRow>[] = [
        { id: 'id', label: 'Id', isPK: true, hidden: true },
        { id: 'name', label: 'Name' },
        { id: 'createdAt', label: 'Created At', type: 'date' },
        { id: 'startDate', label: 'Start date', type: 'date' },
        {
            id: 'productType.name',
            label: 'Product Type',
            customRenderer: x => {
                if (!(x.value)) return null
                return <Chip color='secondary' label={x.value} />
            }
        },
        { id: 'endDate', label: 'End Date', type: 'date' },
        {
            id: 'status.name',
            label: 'Contract Status',
            customRenderer: x => {
                const status = x.value as string
                return getStatusChip(status)
            }
        },
        { id: 'versioning.version', label: 'Version' },
        { id: 'approvalStatus', label: 'Approval Status',
            customRenderer: cell => ApprovalManager.getStatusChip(cell.value as string)
        }
    ]

    const { execute: navigateToContract } = useCommand({
        commandFn: async (item: ContractRow) => {
            const contract = await ApiClient.getContract(item.uuid)
            const contractFiles = await ApiClient.getContractFiles(item.uuid)

            return { contract, contractFiles }
        },
        onFinish: result => {
            dispatch(
                changeRoute({
                    route: 'contract-editor',
                    params: {
                        contractUUID: result.response.contract.uuid,
                        uploadedFiles: result.response.contractFiles ?? []
                    },
                    customRouteName: result.response.contract.name
                })
            )
        }
    })

    const handleRowClick = (indexRow: number, cells: Cell[], row: Row, item: ContractRow) => {
        if (item) {
            navigateToContract(item)
        } else {
            console.error('Items not found in the rows.')
        }
    }
    const searchPending = ['entityName', 'status.name']

    return (
        <SmartCard table={true}>
            <SmartTable<ContractRow>
                key='pending_contracts_table'
                columns={columnsPendings}
                noCollapse
                onClickRow={handleRowClick}
                datasource={{ remote: {
                    url: API_URLS.os.getPendingContracts,
                    onSuccess: response => {
                        const newContractRows: ContractRow[] = response.items as ContractRow[]
                        return { ...response, items: newContractRows } as any
                    }
                } }}
                toolbar={{
                    columns: true,
                    search: searchPending,
                    filters: true,
                    export: {
                        fileName: 'Contracts_table'
                    }
                }}
            />
        </SmartCard>
    )
}
